module.exports = __webpack_public_path__ + "static/media/go_holidays_logo_.d45f71c2.png";